import { HiSortDescending } from "react-icons/hi";
import { FiFilter } from "react-icons/fi";

const ResponsiveFilterButtons = ({ t, setOpenFilterBox, setOpenSortBox }) => {
  return (
    <div className="hidden max-[768px]:flex max-[768px]:items-center max-[768px]:gap-4 max-[768px]:justify-between max-[768px]:mb-4">
      <button
        onClick={() => setOpenFilterBox(true)}
        className="flex items-center p-2 justify-center text-white rounded-md bg-blue campaign:bg-campaignAccent w-full"
      >
        <FiFilter size="19px" />
        <span className="mx-2 max-[991px]:text-sm">{t("Filter")}</span>
      </button>

      <button
        onClick={() => setOpenSortBox(true)}
        className="flex items-center p-2 text-white justify-center rounded-md bg-blue campaign:bg-campaignAccent w-full"
      >
        <HiSortDescending size="19px" />
        <span className="mx-2 max-[991px]:text-sm">{t("SortBy")}</span>
      </button>
    </div>
  );
};

export default ResponsiveFilterButtons;
